import { render, staticRenderFns } from "./IngredientItem.vue?vue&type=template&id=3f83add8&scoped=true&"
import script from "./IngredientItem.vue?vue&type=script&lang=js&"
export * from "./IngredientItem.vue?vue&type=script&lang=js&"
import style0 from "./IngredientItem.vue?vue&type=style&index=0&id=3f83add8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f83add8",
  null
  
)

export default component.exports